module.exports = __webpack_public_path__ + "static/media/mobile-app-bg.367ca56c.jpg";